<div (click)="setActiveReport()"
  class="hg-card-interactive px-4! py-4! flex flex-col items-center justify-center max-h-full h-full max-w-full">

  <div class="w-full flex flex-row items-center justify-between max-w-full">
    <div class="flex justify-between items-center gap-2 px-2 max-w-full">
      <h4 class="text-center truncate">{{ report().name }}</h4>
      @if(isReleaseCandidate) {
      <span class="bg-accent/50 px-2 rounded badge-sm font-bold">RC</span>
      }
    </div>
    @if(product() && !product()?.internal) {
    <button class="p-0! w-fit flex items-center justify-center" (click)="goToProductInfo($event)">
      <span class="material-symbols-outlined hover:text-slate-400"> info </span>
    </button>
    }
  </div>

  <div class="w-full">
    <div class="flex items-center justify-start gap-2 lg:gap-x-4 h-full">
      <span class="text-3xl! lg:text-7xl! material-symbols-outlined">
        {{ product()?.material_icon ?? 'insert_chart' }}
      </span>
      <div class="flex items-center justify-start lg:justify-center overflow-y-auto">
        <span class="text-slate-400 text-xs xl:text-sm leading-4 tracking-tight">
          {{  (isReleaseCandidate ? 'Release Candidate — preview version.' : (product()?.shortDescription ?? 'No description available')) }}
        </span>
      </div>
    </div>
  </div>
</div>